export default function HeroSection() {
  const stats = [
    { label: '收录作品', value: '30,000+' },
    { label: '每日更新', value: '200+话' },
    { label: '类型覆盖', value: '40+种' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden bg-background-100"
    >
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>韩漫 · 日漫 · 国漫 — 全部免费</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight">
              皮皮漫画
              <span className="block text-primary-500">你的掌上漫画图书馆</span>
            </h1>

            <p className="mt-4 text-base md:text-lg lg:text-xl text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              汇聚全网热门韩漫、日漫与国漫资源，提供高清画质、流畅翻页的免费在线阅读体验。无论你热爱浪漫恋爱、热血战斗还是悬疑推理，皮皮漫画韩漫与皮皮漫画日漫专区都已为你准备好每日新鲜内容。
            </p>

            <p className="mt-4 text-sm text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              全站支持手机与电脑阅读，更新及时、加载快速，皮皮漫画国漫类型大全让你轻松发现下一部心头好。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mt-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading text-accent-500">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-colors cursor-pointer whitespace-nowrap"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-book-open-line"></i>
                开始阅读
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full border border-foreground-300 hover:border-primary-500 hover:text-primary-500 text-foreground-700 font-medium text-sm transition-colors cursor-pointer whitespace-nowrap"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#app')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-download-line"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20artistic%20illustration%20of%20a%20digital%20tablet%20displaying%20vibrant%20manga%20comic%20pages%20with%20Japanese%20and%20Korean%20manhwa%20style%20characters%2C%20surrounded%20by%20soft%20ambient%20lighting%2C%20warm%20wooden%20desk%20texture%2C%20a%20cup%20of%20tea%2C%20soft%20bokeh%20background%2C%20editorial%20composition%2C%20rich%20colors%2C%20inviting%20atmosphere%2C%20high%20detail&width=1040&height=780&seq=hero-comic-visual-01&orientation=landscape"
                alt="皮皮漫画在线阅读场景 - 平板设备展示韩漫日漫内容"
                title="皮皮漫画在线阅读"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent pointer-events-none"></div>
    </section>
  );
}